<template>
  <div>
    <el-cascader style="width: 200px;"
                 :options="groups" v-model="tableQuery.formId"
                 :props="{value: 'id',label: 'name',children: 'children'}"
                 collapse-tags placeholder="请选择表单类型"
                 clearable  ></el-cascader>
    <el-select clearable
        v-model="tableQuery.createId" style="width: 180px;margin:0 10px"
        filterable placeholder="请选择发起人" :loading="coachLoading"
        remote reserve-keyword :remote-method="selectCoach">
      <el-option v-for="(coach,index) in coachList" :key="index" :label="coach.name" :value="coach.id">
        {{coach.id}} - {{coach.name}}
      </el-option>
    </el-select>
    <el-select v-model="tableQuery.status" clearable placeholder="请选择状态" style="width: 130px">
      <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"/>
    </el-select>
    <el-date-picker style="margin:0 10px"
                    v-model="tableQuery.applyDate"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
    </el-date-picker>
    <el-button :loading="tableQuery.loading" type="danger" @click="selectPage">搜 索</el-button>
    <el-table border class="table" height="610px"
      :data="tableData"  :cell-style="{padding:0+'px'}"
      v-loading="loading"
      @row-dblclick="handleRowDbClick"
    >
      <el-table-column
        prop="processDefinitionName"
        label="申请表单"
        width="200"
      >
        <template slot-scope="scope">
          <div style="word-break: break-all"><span>{{ scope.row.processDefinitionName }}</span>
            <!-- 批量导入的数据：跟在表单名右上角，悬停显示导入人 -->
            <el-tooltip v-if="scope.row.importName" effect="dark"
                        :content="scope.row.importName + '老师，导入的申请单！'" placement="top">
              <i class="el-icon-upload2"
                 style="position: relative;top: -6px;margin-left: 2px;color: #409EFF;font-size: 14px;font-weight: bold;cursor: pointer"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="170" property="coachName" label="发起人">
        <template #default="coach">
          <div style="display: flex; align-items: center;">
            <!-- 图片容器：增加相对定位，作为性别图标的定位基准 -->
            <div style="position: relative; margin: 10px 10px 2px 0;">
              <el-image
                  style="width: 35px; height: 35px; border-radius: 6px;"
                  :src="coach.row.startUser.portrait"
                  :preview-src-list="[coach.row.startUser.portrait]"
              >
                <div slot="error" class="image-slot" style="display: flex; justify-content: center;">
                  <span class="el-icon-picture-outline" style="margin-top: 10px"></span>
                </div>
              </el-image>
              <!-- 性别图标：绝对定位到图片右上角 -->
              <div v-if="coach.row.startUser.sex === 0" style="color: #F56C6C;" class="el-icon-female sex"></div>
              <div v-if="coach.row.startUser.sex === 1" style="color: #409EFF;" class="el-icon-male sex"></div>
            </div>
            <div>{{ coach.row.startUser.name | truncate }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="businessStatus" label="申请状态" align="center" width="110">
        <template slot-scope="scope">
          <el-tag size="small" :type="businessStatusInfo(scope.row.businessStatus).type">
            {{ businessStatusInfo(scope.row.businessStatus).text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="taskName" label="任务节点名" width="200" />
      <el-table-column
        prop="startTime"
        label="开始时间"
        :formatter="formatTime"
        width="200"
      />
      <el-table-column
        prop="endTime"
        label="完成时间"
        :formatter="formatTime"
        width="200"
      />
      <el-table-column prop="duration" label="耗时" />
      <el-table-column label="操作" width="110" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleRowDbClick(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right; margin-top: 20px;"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40, 50]"
        :current-page.sync="tableQuery.pageNo"
        @current-change="selectPage"
        @size-change="handleSizeChange"
        :page-size="tableQuery.pageSize"
        :total="total"
    />
  </div>
</template>
<script>
import { doneList,getFormGroups } from "@/api/oa/pages";
import {formatTime, formatBusinessStatus, selectBusinessStatusList, businessStatusInfo} from "../form";
import {selectCoach} from "../../../api/contacts/user";

export default {
  data() {
    return {
      statusList:[],
      groups:[],
      coachList:[],
      coachLoading:false,
      tableQuery:{
        name:"",
        applyDate:null,
        loading:false,
        pageNo: 1,
        pageSize: 10,
        formId:[],
        currentUserInfo:{
          id:null
        }
      },
      tableData: [],
      total: 0,
      loading: false,
    };
  },
  methods: {
    // 切换每页条数：回到第一页重新查询
    handleSizeChange(size) {
      this.tableQuery.pageSize = size;
      this.tableQuery.pageNo = 1;
      this.selectPage();
    },
    formatTime,
    formatBusinessStatus,
    businessStatusInfo,
    selectPage() {
      this.loading = true;
      doneList(this.tableQuery).then((rsp) => {
          this.tableData = rsp.data.result.records;
          this.total = rsp.data.result.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectCoach(val){
      this.coachLoading = true;
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.coachLoading = false;
        this.coachList = val.data;
      })
    },
    handleRowDbClick(row) {
      this.$router.push({
        path: "/oa/form/instance/tabs",
        query: {
          processInstanceId: row.processInstanceId,
          type: "doneTask",
        },
      });
    },
  },
  mounted() {
    this.selectCoach();
    this.statusList = selectBusinessStatusList();
    const user = JSON.parse(localStorage.getItem("user"));
    this.tableQuery.currentUserInfo.id = user.id.toString();
    getFormGroups().then(rsp => {
      for (const item of rsp.data) {
        for (const form of item.children) {
          form.id = form.formId;
          form.name = form.formName;
        }
      }
      this.groups = rsp.data;
    })
    this.selectPage();
  },
};
</script>
<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
  margin-top: 20px;
}
</style>